module.exports = __webpack_public_path__ + "img/Number=21.320e8958.png";